module.exports = __webpack_public_path__ + "static/media/compassionIcon.7e5efe0d.png";